import { render, staticRenderFns } from "./ordersListHead.vue?vue&type=template&id=93e86d68&"
import script from "./ordersListHead.vue?vue&type=script&lang=js&"
export * from "./ordersListHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports